module.exports = __webpack_public_path__ + "static/media/calendar-icon-active.434e799e.svg";